export const API_BASE_URL =
  process.env.API_URL || 'https://dev-api.emmacare-dev.com/api'

export const ENVIRONMENT_TYPE = process.env.ENVIRONMENT_TYPE

export const WEBSOCKET_API_KEY =
  process.env.WEBSOCKET_API_KEY || '1Bq9xExsBdKpvivNPnbLWub6sOXdnnU4c5S5AnnQ'

export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json'
}
